const resources = {
    pageTitle: 'Ouvrez une session pour une expérience personnalisée',
    personalizedBeautyTitle: 'Recommandations d’essentiels personnalisées',
    perksTitle: 'Offres et privilèges Beauty Insider',
    adviceTitle: 'Des conseils qui s’améliorent au fil du temps',
    emailPlaceholder: 'Courriel',
    passwordPlaceholder: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    signInButton: 'Ouvrir une session',
    continueAsGuest: 'Continuer sans créer de compte',
    enterPasswordErrorMessage: 'Veuillez saisir votre mot de passe.',
    passwordLengthInvalid: 'Veuillez passer en revue votre mot de passe. Les mots de passe sont composés de 6 à 12 caractères.',
    emailEmpty: 'Veuillez saisir une adresse courriel au format nomutilisateur@domaine.com.',
    emailInvalid: 'Veuillez saisir une adresse courriel au format nomutilisateur@domaine.com.',
    unableToLogYouIn: 'Nous n’avons pas pu vous connecter. Veuillez réessayer.',
    genericErrorMessage: 'Échec de la connexion. Veuillez essayer de nouveau.',
    checkEmailPassword: 'Une erreur se produit avec votre adresse courriel ou votre mot de passe. Veuillez réessayer ou cliquer sur \« Mot de passe oublié »\.',
    verificationFailedTitle: 'Échec de la vérification',
    verificationFailedMessage: 'Nous n’avons pas été en mesure de vérifier votre session. Veuillez vous déconnecter et vous reconnecter pour continuer.',
    verificationFailedButton: 'OK',
    createAccount: 'Créer un compte',
    existingUserError: 'Nous sommes désolés. Une erreur se produit avec votre adresse courriel ou votre mot de passe. N’oubliez pas : les mots de passe doivent être composés de 6 à 12 caractères (lettres ou chiffres). Veuillez réessayer ou cliquer sur « Mot de passe oublié ».',
    authorizationFailed: 'L’autorisation a échoué. Veuillez essayer de nouveau.',
    errorMessage: 'Une erreur s’est produite. Veuillez essayer de nouveau.',
    backButtonAriaLabel: 'Retour',
    signInAllowAccess: 'Se connecter et autoriser l’accès'
};

export default function getResource(label) {
    return resources[label];
}
